module.exports = __webpack_public_path__ + "media/img/quote-2-8ffb4fcf.png";